import { takeEvery } from "redux-saga/effects";
import {
  FETCH_CLIENT,
  FETCH_GEO_LOCATION,
  FETCH_CLIENT_BRANDING,
  FETCH_CLIENT_NETWORK
} from "../../state/client/constants";
import fetchClient from "./fetchClient";
import fetchGeoLocation from "./fetchGeoLocation";
import fetchClientBranding from "./fetchClientBranding";
import fetchClientNetwork from "./fetchClientNetwork";

function* client() {
  yield takeEvery(FETCH_CLIENT, fetchClient);
  yield takeEvery(FETCH_GEO_LOCATION, fetchGeoLocation);
  yield takeEvery(FETCH_CLIENT_BRANDING, fetchClientBranding);
  yield takeEvery(FETCH_CLIENT_NETWORK, fetchClientNetwork);
}

export default client;
